import { CaretDownFilled, FilterOutlined, SearchOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Input,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  Menu,
  Checkbox,
  Dropdown,
} from 'antd'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { User } from '../../../../models/user'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { getFullUserList } from '../../../completion/completionSlice'
import { getFullDoctorList } from '../../../registration/list/registrationSlice'
import styles from './dentureLedgerPage.module.css'
import { DateRangeFieldName, DateRangeType, DateSelect, getDateRange } from '../../../../compnents/form/DateSelect'

export const Query = (props: {
  loading?: any
  exportLoading?: any
  filterColumn?: any
  filterSelectList?: any
  onColumnVisibilityChange?: (selectedColumns: string[]) => void
  onValueChange: (params: any) => void
  exportExcel: () => void
  add: () => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const [visible, setVisible] = useState<any>(false)

  const dropdownRef = useRef<HTMLDivElement>(null)

  const [doctors, setDoctors] = useState<any>([])

  const [current, setCurrent] = useState<any>()

  const [head, tail] = getDateRange(DateRangeType.Today)

  const [selectedColumns, setSelectedColumns] = useState<string[]>([])

  // 筛选中默认勾选的值
  const filterColumnSelectList: any = props?.filterSelectList

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_yichitaizhang') || '{}'
  )

  useEffect(() => {
    if (
      Object.keys(storageParams).length
    ) {
      form.setFieldsValue({
        ...storageParams,
        timeHead: storageParams?.startDate || head,
        timeTail: storageParams?.endDate || tail,
        [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
      })
    } else {
      form.setFieldsValue({
        _dateRange: 0,
        timeHead: head,
        timeTail: tail,
      })
    }
    refresh()
  }, [])

  const refresh = () => {
    props.onValueChange({
      ...storageParams,
      ...form.getFieldsValue(),
      current: current || 1,
    })
  }

  useEffect(() => {
    dispatch(getFullDoctorList())
      .then(unwrapResult)
      .then((ds: any) => setDoctors(ds))
      .catch(() => {
        // do nothing
      })
  }, [])

  // 处理列选中状态变化
  const handleColumnChange = (columnKey: string, checked: boolean) => {
    if (checked) {
      const data = [...selectedColumns, columnKey]
      setSelectedColumns(data);
      props?.onColumnVisibilityChange && props.onColumnVisibilityChange(data);
    } else {
      const data = selectedColumns.filter(key => key != columnKey)
      setSelectedColumns(data);
      props?.onColumnVisibilityChange && props.onColumnVisibilityChange(data);
    }
  }

  useEffect(() => {
    setSelectedColumns(filterColumnSelectList)
  }, [visible])
  // 列筛选菜单
  const columnMenu = (
    <Menu>
      <Menu.ItemGroup title="筛选列">
        {props?.filterColumn?.filter((item: any) => item?.field != 'checkbox')?.map((column: any) => {
          return (
            <Menu.Item key={column?.field}>
              <Checkbox
                checked={selectedColumns?.includes(column.field)}
                disabled={column?.pinned || column?.filter == false ? true : false}
                onChange={(e) => handleColumnChange(column.field, e.target.checked)}
              >
                {column?.headerName}
              </Checkbox>
            </Menu.Item>
          )
        })}
      </Menu.ItemGroup>
      <Menu.Divider />
    </Menu>
  )
  return (
    <Form
      className={styles.formStyle}
      form={form}
      onFinish={(values) => {
        const data =
          storageParams || {}
        const dataParams = {
          ...data,
          ...values,
          current: current,
        }
        props.onValueChange({
          ...dataParams,
        })
      }}
    >
      <Row style={{ marginBottom: 10 }} justify='space-between'>
        <Space>
          <DateSelect
            allowClear={false}
            style={{ width: '8.5rem' }}
            labelPrefix=''
            namePrefix='time'
            placeholder='时间范围-时间'
            initialValue={DateRangeType.Today}
            onChange={(e) => {
              if (e != 6) {
                refresh()
              }
            }}
          />
          <Form.Item noStyle name='keyWord'>
            <Input
              autoComplete='off'
              maxLength={20}
              placeholder='患者姓名/助记码/手机号/病历号'
              style={{ width: '15rem' }}
              allowClear
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            />
          </Form.Item>
          <Form.Item noStyle name='variety'>
            <Input
              autoComplete='off'
              maxLength={20}
              placeholder='义齿品种'
              style={{ width: '8rem' }}
              allowClear
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            />
          </Form.Item>
          <Form.Item name='doctorId' noStyle>
            <Select
              allowClear
              placeholder='医生'
              style={{
                width: '8rem',
              }}
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            >
              {doctors.map((d: any) => (
                <Select.Option key={d.id} value={d.id}>
                  {d.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              setCurrent(1)
              refresh()
            }}
          >
            查询
          </Button>
          <div ref={dropdownRef}>
            <Dropdown
              overlay={columnMenu}
              trigger={['click']}
              onVisibleChange={(newVisible) => {
                setVisible(newVisible);
              }}
              visible={visible}>
              <FilterOutlined
                style={{ fontSize: '16px' }}
                onClick={(e) => {
                  e.stopPropagation();
                  setVisible(!visible);
                }}
              />
            </Dropdown>
          </div>
        </Space>
        <Space>
          <Button
            loading={props?.exportLoading}
            type='primary'
            onClick={() => {
              props?.exportExcel && props?.exportExcel()
            }}
          >
            导出
          </Button>
          <Button
            type='primary'
            onClick={() => {
              props?.add && props?.add()
            }}
          >
            新增
          </Button>
        </Space>
      </Row>
    </Form>
  )
}

